import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

export const findBySaleId = ({data, headers}) => {
    return axios.get(`${API_URL}/beneficiary/findBySaleId/${data.saleId}`, { headers });
}
